import { createSlice } from "@reduxjs/toolkit";

const emailTemplatesStage = localStorage.getItem("emailTemplates");
const whatsappTemplatesStage = localStorage.getItem("whatsappTemplates");
const smsTemplatesStage = localStorage.getItem("smsTemplates");
const resetEmailTemplatesStage = localStorage.getItem("resetEmailTemplates");

const initialState = {
  emailTemplates:
    emailTemplatesStage &&
    emailTemplatesStage !== "undefined" &&
    JSON.parse(emailTemplatesStage)?.length > 0
      ? JSON.parse(emailTemplatesStage)
      : [],
  whatsappTemplates:
    whatsappTemplatesStage &&
    whatsappTemplatesStage !== "undefined" &&
    JSON.parse(whatsappTemplatesStage)?.length > 0
      ? JSON.parse(whatsappTemplatesStage)
      : [],
  smsTemplates:
    smsTemplatesStage &&
    smsTemplatesStage !== "undefined" &&
    JSON.parse(smsTemplatesStage)?.length > 0
      ? JSON.parse(smsTemplatesStage)
      : [],
  resetEmailTemplates:
    resetEmailTemplatesStage &&
    resetEmailTemplatesStage !== "undefined" &&
    JSON.parse(resetEmailTemplatesStage)?.length > 0
      ? JSON.parse(resetEmailTemplatesStage)
      : {},
  isLoading: false,
};

export const templateSlice = createSlice({
  name: "template",
  initialState,
  reducers: {
    startLoading: (state) => {
      state.isLoading = true;
    },
    stopLoading: (state) => {
      state.isLoading = false;
    },
    setEmailTemplates: (state, action) => {
      state.emailTemplates = action.payload;
    },
    setWhatsappTemplates: (state, action) => {
      state.whatsappTemplates = action.payload;
    },
    setResetEmailTemplates: (state, action) => {
      state.resetEmailTemplates = action.payload;
    },
    setSMSTemplates: (state, action) => {
      state.smsTemplates = action.payload;
    },
    singOutTemplates: (state) => {
      state.emailTemplates = [];
      state.smsTemplates = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setWhatsappTemplates,
  setSMSTemplates,
  startLoading,
  stopLoading,
  setEmailTemplates,
  singOutTemplates,
  setResetEmailTemplates,
} = templateSlice.actions;
